import { render, staticRenderFns } from "./budgetSourceComponent.vue?vue&type=template&id=5063b322&scoped=true&"
import script from "./budgetSourceComponent.vue?vue&type=script&lang=js&"
export * from "./budgetSourceComponent.vue?vue&type=script&lang=js&"
import style0 from "./budgetSourceComponent.vue?vue&type=style&index=0&id=5063b322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063b322",
  null
  
)

export default component.exports